import WebAnimation from './WebAnimation.js';

function Tween(obj, options) {
    
    options  = options || {}
    
    if (typeof options.to === void 0) {
        throw('cannot create a tween witout values', obj)
    }

    let startValues = {}
    
    for (let k in options.to) {
        startValues[k] = obj[k];
    }

    let t = new WebAnimation({
        debug: options.debug,
        step: (e)=>{
            for (let k in options.to) {
                obj[k] = startValues[k] + (options.to[k]-startValues[k]) * e
            }
            options.step && options.step(e)
        },
        end:        options.end      ,
        delay:      options.delay    ,
        duration:   options.duration ,
        easing:     options.easing    
    });

    t.play();

    return t;


}


export default Tween
